module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "two-factor-authentication"
    }
  }, [_c('div', [_c('h1', {
    staticClass: "init-block--heading"
  }, [_vm._v(_vm._s(_vm.t('global.two_factor_authentication')))]), _vm._v(" "), _c('div', {
    staticClass: "subheader u-mb3"
  }, [_vm._v(_vm._s(_vm.t('global.select_the_mfa_method')))])]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.selectedMethod),
      callback: function($$v) {
        _vm.selectedMethod = $$v
      },
      expression: "selectedMethod"
    }
  }, [(_vm.authenticatorAppActive) ? _c('div', [_c('el-radio', {
    staticClass: "u-mt3",
    attrs: {
      "label": "authenticator-app",
      "checked": _vm.selectedMethod === "authenticator-app"
    },
    model: {
      value: (_vm.selectedMethod),
      callback: function($$v) {
        _vm.selectedMethod = $$v
      },
      expression: "selectedMethod"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.t('global.authenticator_app')) + "\n      ")])], 1) : _vm._e(), _vm._v(" "), (_vm.emailOptions.length) ? _c('div', [_c('el-radio', {
    staticClass: "u-mt3",
    attrs: {
      "label": "email",
      "checked": _vm.selectedMethod === "email"
    },
    model: {
      value: (_vm.selectedMethod),
      callback: function($$v) {
        _vm.selectedMethod = $$v
      },
      expression: "selectedMethod"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.t('global.email')) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "u-pl4"
  }, [(_vm.selectedMethod === 'email' && _vm.emailOptions.length > 1) ? _c('el-select', {
    model: {
      value: (_vm.selectedMethodId),
      callback: function($$v) {
        _vm.selectedMethodId = $$v
      },
      expression: "selectedMethodId"
    }
  }, _vm._l((_vm.emailOptions), function(email, i) {
    return _c('el-option', {
      key: email.value + i,
      attrs: {
        "label": email.label,
        "value": email.value
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.selectedMethod === 'email') ? _c('el-button', {
    staticClass: "remove-background",
    attrs: {
      "type": "text",
      "disabled": _vm.disabledSendCodeButtons
    },
    on: {
      "click": _vm.sendCode
    }
  }, [_vm._v(_vm._s(_vm.t('global.send_code')))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.phones.length) ? _c('div', [_c('el-radio', {
    staticClass: "u-mt3",
    attrs: {
      "label": "sms",
      "checked": _vm.selectedMethod === "sms"
    },
    model: {
      value: (_vm.selectedMethod),
      callback: function($$v) {
        _vm.selectedMethod = $$v
      },
      expression: "selectedMethod"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.t('global.sms')) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "u-pl4"
  }, [(_vm.selectedMethod === 'sms' && _vm.phoneOptions.length > 1) ? _c('el-select', {
    model: {
      value: (_vm.selectedMethodId),
      callback: function($$v) {
        _vm.selectedMethodId = $$v
      },
      expression: "selectedMethodId"
    }
  }, _vm._l((_vm.phoneOptions), function(phone) {
    return _c('el-option', {
      key: phone.value,
      attrs: {
        "label": phone.label,
        "value": phone.value
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.selectedMethod === 'sms') ? _c('el-button', {
    staticClass: "remove-background",
    attrs: {
      "type": "text",
      "disabled": _vm.disabledSendCodeButtons
    },
    on: {
      "click": _vm.sendCode
    }
  }, [_vm._v(_vm._s(_vm.t('global.send_code')))]) : _vm._e()], 1)], 1) : _vm._e()]), _vm._v(" "), _c('el-form', {
    staticClass: "mx-auto form-container"
  }, [(!_vm.mfaCodeError) ? _c('div', {
    staticClass: "subheader u-mb3"
  }, [_vm._v(_vm._s(_vm.t('global.enter_the_code_generated')))]) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    class: {
      'u-input-error': _vm.mfaCodeError
    },
    attrs: {
      "disabled": _vm.blockVerifyProcess
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.performVerification.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.code),
      callback: function($$v) {
        _vm.code = $$v
      },
      expression: "code"
    }
  }), _vm._v(" "), (_vm.mfaCodeError) ? _c('div', {
    staticClass: "u-input-validation u-danger u-pt2 u-pb1"
  }, [_vm._v("\n        " + _vm._s(_vm.mfaCodeError) + "\n      ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "verify-button el-button--wide u-text-uppercase",
    attrs: {
      "data-cy": "button__sign-in",
      "type": "primary",
      "disabled": _vm.blockVerifyProcess
    },
    on: {
      "click": _vm.performVerification
    }
  }, [_vm._v("\n    " + _vm._s(_vm.t('global.verify')) + "\n  ")])], 1)
},staticRenderFns: []}